import { parse, theme } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  bg: "black",
  position: "relative"
}, "cu2rudd");
export const flex = parse({
  display: "flex",
  py: {
    _: "112",
    medium: "112",
    large: "80"
  }
}, "fc7eirl");
export const logo = parse({
  position: 'absolute'
}, "l1ncrngf");
export const address = parse({
  textAlign: {
    _: 'center',
    medium: 'left'
  },
  mb: {
    _: '24',
    medium: '0'
  }
}, "aw49gj0");
export const contactDetails = parse({
  mb: {
    _: '24',
    medium: '0'
  }
});
export const contact = parse({
  display: 'flex',
  justifyContent: {
    _: 'flex-end'
  },
  alignItems: 'center'
}, "c1wxdvm0");
export const link = parse({
  display: 'flex',
  justifyContent: {
    _: 'center',
    medium: 'flex-end'
  },
  ml: {
    _: '16'
  }
}, "larotpo");

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");